import { AuthService } from '@/pages/service/auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const isLoggedIn = this.authService.isLoggedIn();
        const isRootRoute = state.url === '/';
        const isDashboard = state.url.includes('/dashboard');

        // Si no está logueado, redirigir al login
        if (!isLoggedIn) {
            this.router.navigate(['/auth/login']);
            return false;
        }

        // Validar datos de usuario
        const user = this.getUser();
        if (!user) {
            this.authService.clearSession();
            this.router.navigate(['/auth/login']);
            return false;
        }

        // Si está en la ruta raíz, redirigir según rol
        if (isRootRoute) {
            this.redirectBasedOnRole(user);
            return false;
        }

        // Bloquear acceso al dashboard para colaboradores y superadministrador
        if (isDashboard) {
            const mainRole = user.roles?.[0]?.toLowerCase() || '';
            if (mainRole === 'colaborador') {
                this.router.navigate(['/control']);
                return false;
            }
            if (mainRole === 'superadministrador') {
                this.router.navigate(['/virtual']);
                return false;
            }
        }

        // Bloquear acceso a Invitaciones para usuarios con sede asignada (sede_id != null)
        if (state.url.includes('/administracion/invitaciones')) {
            if (user.sede_id !== null && user.sede_id !== undefined) {
                this.redirectBasedOnRole(user);
                return false;
            }
        }

        // Bloquear acceso a /virtual para roles que no sean superadministrador
        if (state.url.includes('/virtual')) {
            const mainRole = user.roles?.[0]?.toLowerCase() || '';
            if (mainRole !== 'superadministrador') {
                this.redirectBasedOnRole(user);
                return false;
            }
        }

        return true;
    }

    private getUser(): any {
        try {
            const userStr = this.authService.user;
            if (!userStr) return null;

            const user = JSON.parse(userStr);
            if (!user.roles || user.roles.length === 0) return null;

            return user;
        } catch {
            return null;
        }
    }

    private redirectBasedOnRole(user: any): void {
        const mainRole = user.roles?.[0]?.toLowerCase() || '';

        switch (mainRole) {
            case 'superadministrador':
                this.router.navigate(['/virtual']);
                break;
            case 'administrador':
                this.router.navigate(['/dashboard']);
                break;
            case 'colaborador':
                this.router.navigate(['/control']);
                break;
            default:
                this.router.navigate(['/control']);
        }
    }
}
